import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { debitCard, DebitCardManipulationViewModel } from "./debitCardManipulation-viewModel"

export class DebitCardManipulationView extends View<DebitCardManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-A0DD7DA8-56DD-49B7-B097-989BCD326FFB"
    }
    loadHtml(): string {
        let element = require('./debitCardManipulation.html').default;
        let style = require('./debitCardManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set debitCard(v: ObservableArray<debitCard>) { this._debitCard = v; } public get debitCard(): ObservableArray<debitCard> { return this._debitCard;} private _debitCard: ObservableArray<debitCard>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestDebitCardCreation(){
        this.dataContext.requestDebitCardCreation();
    }
}
